import React from 'react';
import type { User } from '@netlify/identity';
import { CloudAccount } from './CloudAccount';

type Props = { user: User | null; localMode: boolean; syncStatus: string; databaseMode: 'turso' | 'sqlite' | 'unavailable' };

export function AccountPage(props: Props) {
  return <section className="page-section account-page">
    <div className="page-title-row"><div><p className="eyebrow">YOUR REPday ACCOUNT</p><h1>Account</h1><p className="welcome-copy">Sign in to keep your training data synced across browsers and devices.</p></div></div>
    <CloudAccount {...props}/>
  </section>;
}
